import { createContext, useContext, useMemo } from 'react';

const AppContext = createContext(null);

function getAppType() {
    const hostname = window.location.hostname;

    const adminPrefix = process.env.REACT_APP_ADMIN_PREFIX;
    const mdPrefix = process.env.REACT_APP_MD_PREFIX;

    if (hostname.startsWith(adminPrefix)) return 'ADMIN';
    if (hostname.startsWith(mdPrefix)) return 'MD';

    // fallback
    return 'MD';
}

export function AppProvider({ children }) {
    const appType = useMemo(() => getAppType(), []);

    return <AppContext.Provider value={{ appType }}>{children}</AppContext.Provider>;
}

export function useApp() {
    return useContext(AppContext);
}
